import * as React from "react";

import {
  Card,
  CardStackSection,
  Heading,
  Stack,
  Text,
} from "@origin-digital/ods-core";
import { IconError } from "@origin-digital/ods-icons";

export const ErrorPage = () => (
  <CardStackSection>
    <Card>
      <Stack alignX="center" data-id="error-page">
        <IconError tone="critical" size="medium" />
        <Heading variant="h3" align="center">
          Sorry, something went wrong!
        </Heading>
        <Text align="center">
          Please check back again later. Hopefully things will be back to normal
          by then.
        </Text>
      </Stack>
    </Card>
  </CardStackSection>
);
